import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import {
  ClientPortalBudgetChargesModel,
  ClientPortalBudgetHeadersModel,
  ClientPortalBudgetsModel,
  ICPLClientPortalBudgetsClient,
} from "./api/cplapi/CPLAPI";

export interface IClientPortalBudgetsService {
  getBudgetsForClient(clientID: string): Promise<ClientPortalBudgetsModel>;
  getBudgetHeadingsForClientsBudget(clientID: string, budgetID: number): Promise<ClientPortalBudgetHeadersModel>;
  getChargesForClientsBudgetHeading(
    clientID: string,
    budgetID: number,
    budgetHeaderID: number
  ): Promise<ClientPortalBudgetChargesModel>;
}

@injectable()
export class ClientPortalBudgetsService implements IClientPortalBudgetsService {
  @inject(SERVICE_TYPES.CPLClientPortalBudgetsClient)
  cplClientPortalBudgetsClient!: ICPLClientPortalBudgetsClient;

  getBudgetsForClient(clientID: string): Promise<ClientPortalBudgetsModel> {
    return this.cplClientPortalBudgetsClient.getBudgetsForClient(clientID);
  }

  getBudgetHeadingsForClientsBudget(clientID: string, budgetID: number): Promise<ClientPortalBudgetHeadersModel> {
    return this.cplClientPortalBudgetsClient.getBudgetHeadingsForClientsBudget(clientID, budgetID);
  }

  getChargesForClientsBudgetHeading(
    clientID: string,
    budgetID: number,
    budgetHeaderID: number
  ): Promise<ClientPortalBudgetChargesModel> {
    return this.cplClientPortalBudgetsClient.getChargesForClientsBudgetHeading(clientID, budgetID, budgetHeaderID);
  }
}
